document.addEventListener('DOMContentLoaded', function() {
    // 1. 获取所有需要操作的 DOM 元素
    const expandIcon = document.querySelector('.expand-header-drawer-icon');
    const utilityBar = document.querySelector('.utility-bar.gradient');
    const closeIcon = document.querySelector('.close-svg-wrapper');
    const headerDrawer = document.querySelector('.header-drawer-custom-wrapper');
    const headerDrawerGrey = document.querySelector('.header-drawer-grey');
    const headerTab = document.querySelector('.header-tab-wrapper');

    // 确保所有必要的元素都已找到，避免后续操作出错
    if (!expandIcon || !closeIcon || !headerDrawer || !headerDrawerGrey) {
        console.error('一个或多个必要的元素未在页面中找到。请检查类名是否正确。');
        console.error('缺失的元素:', {
            expandIcon: !expandIcon,
            closeIcon: !closeIcon,
            headerDrawer: !headerDrawer,
            headerDrawerGrey: !headerDrawerGrey
        });
        return; // 如果有元素未找到，则停止执行后续代码
    }

    // 2. 当点击展开图标 (expand-header-drawer-icon) 时
    expandIcon.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        console.log('展开图标被点击');
        
        // 显示灰色背景遮罩 - 添加淡入效果
        if (headerDrawerGrey) {
            headerDrawerGrey.classList.remove('isVisible');
            headerDrawerGrey.style.display = "inline-block";
            // 使用 requestAnimationFrame 确保 display 改变后再添加淡入类
            requestAnimationFrame(() => {
                headerDrawerGrey.classList.add('fade-in');
            });
            console.log('灰色背景已显示');
        }
        
        // 显示抽屉内容 - 先显示元素，然后触发动画
        if (headerDrawer) {
            headerDrawer.classList.remove('isVisible');
            headerDrawer.style.display = "block";
            // 使用 requestAnimationFrame 确保 display 改变后再添加动画类
            requestAnimationFrame(() => {
                headerDrawer.classList.add('drawer-open');
            });
            console.log('抽屉内容已显示');
        }
        
        // 禁止页面滚动
        document.body.style.overflow = 'hidden';
    });

    // 3. 当点击关闭图标 (close-svg-wrapper) 时
    closeIcon.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        console.log('关闭图标被点击');
        
        // 隐藏灰色背景遮罩 - 先移除淡入类，然后隐藏元素
        if (headerDrawerGrey) {
            headerDrawerGrey.classList.remove('fade-in');
            // 等待动画完成后再隐藏元素
            setTimeout(() => {
                headerDrawerGrey.classList.add('isVisible');
                headerDrawerGrey.style.display = "none";
            }, 300); // 300ms 对应 CSS transition 的时间
        }
        
        // 隐藏抽屉内容 - 先移除动画类，然后隐藏元素
        if (headerDrawer) {
            headerDrawer.classList.remove('drawer-open');
            // 等待动画完成后再隐藏元素
            setTimeout(() => {
                headerDrawer.classList.add('isVisible');
                headerDrawer.style.display = "none";
            }, 300); // 300ms 对应 CSS transition 的时间
        }
        
        // 恢复页面滚动
        document.body.style.overflow = '';
    });


    // 移动端侧边拉出来的抽屉
    if(headerTab){
 // 1. 获取所有可点击的图标容器
    const iconWrappers = document.querySelectorAll('.svg-show-close');

    /**
     * 用于将所有菜单项重置为“折叠”状态的辅助函数
     */
    function closeAllTabs() {
        document.querySelectorAll('.tabItem').forEach(item => {
            const content = item.querySelector('.header-tab-expand-wrapper');
            const iconShow = item.querySelector('.svg-show');
            const iconClose = item.querySelector('.svg-close');

            // 确保这些元素存在再进行操作
            if (content && iconShow && iconClose) {
                // 折叠状态的样式：
                content.classList.add('isVisible');      // 隐藏子菜单内容
                iconShow.classList.remove('isVisible');  // 显示“展开”图标 (+)
                iconClose.classList.add('isVisible');    // 隐藏“关闭”图标 (^)
            }
        });
    }

    // 2. 页面加载完成后，立即调用一次，确保所有菜单都处于正确的初始折叠状态
    closeAllTabs();

    // 3. 遍历每一个图标容器并为其添加点击事件
    iconWrappers.forEach(wrapper => {
        wrapper.addEventListener('click', function(event) {
            
            // 阻止链接的默认跳转行为，以防万一
            event.preventDefault(); 
            
            // 找到当前点击的图标所在的父级 .tabItem
            const currentTabItem = this.closest('.tabItem');
            
            // 获取当前项需要控制的元素
            const contentToExpand = currentTabItem.querySelector('.header-tab-expand-wrapper');
            const iconShow = currentTabItem.querySelector('.svg-show');
            const iconClose = currentTabItem.querySelector('.svg-close');

            // 检查当前子菜单是否是折叠的
            const isCurrentlyCollapsed = contentToExpand.classList.contains('isVisible');
            
            // 4. 在做任何动作之前，先将所有项恢复为折叠状态
            closeAllTabs();
            
            // 5. 如果当前点击的项原本是折叠的，那么就展开它
            if (isCurrentlyCollapsed) {
               
                contentToExpand.classList.remove('isVisible'); 
                iconShow.classList.add('isVisible');         
                iconClose.classList.remove('isVisible');     // 显示“关闭”图标 (^)
            }
           
        });
    });
    }




});